export default function RankingPage() {
    return <div className="py-10 text-3xl font-black text-white">Classement</div>;
}